let backendUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:8000/api';
let frontendUrl = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL : 'http://localhost:3000'
let downloadUrl = 'http://localhost:4005';
let env = process.env.NODE_ENV;
let S3_BASE_URL = 'http://eztask-local.s3.amazonaws.com/'
let outlookClientId = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_AZURE_CLIENT_ID : null;

export const outlookClientID = outlookClientId;
export const backend_url = backendUrl;
export const frontend_url = frontendUrl;
export const download_url = downloadUrl;
export const environment = env;
export const S3baseURL = S3_BASE_URL;